import {
    ActivitySortFields,
    ArticleSortFields,
    AssetSortFields,
    ContentSortFields,
    LanguageWithWildcard,
    MechanicSortFields,
    ProductSortFields,
} from "@/shared/services/graphql/generated/consumer-graph-types";
import { SortEntry } from "@/shared/components/sort-dropdown/sort-dropdown.model";

export type SortFields =
    | ContentSortFields
    | MechanicSortFields
    | ProductSortFields
    | AssetSortFields
    | ArticleSortFields
    | ActivitySortFields;

/**
 * Products, Assets, Articles, and Mechanics can have multiple languages for the title field.
 * To ensure that the correct language-specific title field is used, we have to append the language code to the field name when sorting by title. Also, further sort entries for fallback languages of the acceptes languages array are generated.
 * This function generates the appropriate sort entries based on the provided sort information and the accepted languages.
 *
 * @param sort
 * @param acceptedLanguages
 * @returns An array of sort entries with language-specific fields if the sort field is "title", else an array with the original sort entry.
 */
export function getSortEntries(sort: SortEntry | undefined, acceptedLanguages: LanguageWithWildcard[]): SortEntry[] {
    if (!sort) return [];
    if (sort.field === "title") {
        return acceptedLanguages.map((language) => {
            return {
                field: sort.field.concat("_").concat(language) as SortFields,
                order: sort.order,
            };
        });
    }
    return [sort];
}
